/** https://docs.tsafe.dev/objectFromEntries */
function objectFromEntries(entries) {
    return Object.fromEntries(entries);
}

export { objectFromEntries };
//# sourceMappingURL=objectFromEntries.mjs.map
